import React, { useCallback, useContext }         from "react";
import { StyleSheet, View, Text }                 from "react-native";
import Row                                        from "../../../layouts/Row";
import Col                                        from "../../../layouts/Col";
import Heading                                    from "../../Heading/index";
import SolidButton                                from "../../Buttons/SolidButton/index";
import palette                                    from "../../../styles/palette";
import CustomersContext                           from "../../../contexts/CustomersContext";
import { useHistory }                             from "react-router-dom";

export default function CustomersActionBar() {
  const { total } = useContext(CustomersContext);
  const history = useHistory();

  const onCreateCustomer = useCallback(() => {
    history.push({ hash: "new-customer" });
  }, [history]);

  return (
    <View style={[styles.customers_header__container]}>
      <Row pl={16} pr={8}>
        <Col>
          <Row>
            <Col style={{ flex: "auto" }}>
              <Heading>Customers</Heading>
            </Col>
            <Col pl={12} pt={8} pr={12} leftCenter>
              {!!total && (
                <Text style={[styles.context_header__count_text]}>
                  {total} Customers
                </Text>
              )}
            </Col>
          </Row>
        </Col>
        <Col rightCenter>
          <Row right>
            <SolidButton
              disabled
              icon="download"
              label="Export"
              color={palette.white}
              labelColor={palette.primary}
              mr={12}
            />
            <SolidButton
              icon="user-plus"
              label="Add New"
              color={palette.success}
              onPress={onCreateCustomer}
            />
          </Row>
        </Col>
      </Row>
    </View>
  );
}

const styles = StyleSheet.create({
  customers_header__container: {
    borderBottomWidth: 1,
    borderBottomColor: palette.light_grey,
    height: 75,
  },
  context_header__count_text: {
    color: palette.grey,
    fontSize: 16,
  },
});
